import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';

Swiper.use([Navigation, Pagination, Thumbs]);

let sliderInstance = null;

const initSliders = () => {
  const container = document.querySelector('.gallery-navigation--thumbnails');

  if (!container) return;

  if (sliderInstance && sliderInstance.destroy) {
    sliderInstance.destroy(true, true);
  }


  sliderInstance = new Swiper(container, {
    slidesPerView: 4,
    spaceBetween: 5,
    navigation: {
      nextEl: '.scroll-right',
      prevEl: '.scroll-left',
    },
    breakpoints: {
      900: { slidesPerView: 6 },
      1350: { slidesPerView: 7 },
      1400: { slidesPerView: 8 },
    },
  });
};

export { initSliders };
